import { render, staticRenderFns } from "./Firma.vue?vue&type=template&id=1c66686b&scoped=true&"
import script from "./Firma.vue?vue&type=script&lang=js&"
export * from "./Firma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c66686b",
  null
  
)

export default component.exports